import styles from './imageRadioButtons.module.css';
import React from 'react';

function ImageRadioButtons({ options, name, selectedValue, onChange }) {
    return (
        <div className={styles.container}>
            {options.map(({ id, label, imgSrc }) => (
                <label key={id} className={styles.optionLabel}>
                    <img
                        src={imgSrc}
                        alt={label}
                        className={styles.optionImage}
                    />
                    <input
                        type="radio"
                        name={name}
                        value={id}
                        checked={selectedValue === id}
                        onChange={() => onChange(id)}
                        className={styles.radioInput}
                    />
                    <span className={styles.optionText}>{label}</span>
                </label>
            ))}
        </div>
    );
}

export default ImageRadioButtons;